import { combineReducers } from 'redux';
import specReducer from './xyzFeature/Reducers';
// import authReducer from "./auth/authReducer";

export default combineReducers({ specData: specReducer });
